/**
 * Update user's last login timestamp in the database
 * @param {string} userId - The user's ID
 */
export const updateLastLogin = async (userId) => {
  if (!userId) {
    console.warn('⚠️ No user ID provided for last login update');
    return;
  }

  try {
    // Get API URL
    const apiUrl = process.env.REACT_APP_API_URL;

    // Call backend endpoint to update last login
    const response = await fetch(`${apiUrl}/update-last-login`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        user_id: userId,
        timestamp: new Date().toISOString()
      })
    });

    if (response.ok) {
      console.log('✅ Last login updated successfully');
    } else {
      console.warn('⚠️ Failed to update last login:', response.status);
    }
  } catch (error) {
    console.warn('⚠️ Error updating last login:', error);
    // Don't throw - this is non-critical functionality
  }
};